import React, { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './selectFilter.module.scss';
import { useClickOutside, useFixedDropdownPosition } from '../../../utils';
import { Button, Icon, Multiselect, Checkbox } from '../..';
import FilterTitle from '../_elements/filterTitle/filterTitle';

const SelectFilter = ({
  array = [],
  title,
  valueType,
  filterState,
  setFilterState,
  onSubmit,
  sortOrder,
  setSortOrder,
  name,
  position,
  isActive,
  sortArray,
  disabled,
}) => {
  const [value, setValue] = useState('');
  const [list, setList] = useState([]);
  const [shouldSort, setShouldSort] = useState(false);

  useEffect(() => {
    const filteredList = array.filter(item =>
      item.name.toLowerCase().includes(value.trim().toLowerCase())
    );
    setList(filteredList);
  }, [value, array]);

  const filterRef = useRef();
  const dropdownRef = useRef();
  const [isOpen, setIsOpen] = useClickOutside(filterRef);
  const dropdownStyle = useFixedDropdownPosition({
    triggerRef: filterRef,
    dropdownRef,
    isOpen,
    position,
  });

  const isAllChecked = array.length === filterState.length;

  const handleCheckAll = () => {
    const newList = list.map(item => item.value);
    isAllChecked ? setFilterState([]) : setFilterState(newList);
  };

  const handleTitleClick = () => {
    if (disabled) {
      return;
    }

    if (!isOpen) {
      setShouldSort(false);
    }
    isOpen ? setIsOpen(false) : setIsOpen(true);
  };

  const handleOrderClick = () => {
    if (disabled) {
      return;
    }

    setShouldSort(true);
    sortOrder === 'asc' ? setSortOrder('desc') : setSortOrder('asc');
  };

  const handleSubmit = () => {
    if (disabled) {
      return;
    }

    setIsOpen(false);
    onSubmit(shouldSort ? { sortBy: name } : {});
  };

  return (
    <div className={styles.container} ref={filterRef}>
      <FilterTitle
        title={title}
        onTitleClick={handleTitleClick}
        isActive={isActive}
        disabled={disabled}
      />

      {isOpen && (
        <div
          ref={dropdownRef}
          className={cn(styles.filter, styles[position])}
          style={dropdownStyle}
        >
          <div className={styles.search}>
            <input
              type="search"
              placeholder="Paieška"
              className={styles.input}
              value={value}
              disabled={disabled}
              onChange={e => setValue(e.target.value)}
            />
            <Icon name="search" classes={{ icon: styles.icon }} />
          </div>

          <div className={styles.list}>
            {!value.length && (
              <Checkbox
                label="Visi"
                name="Visi"
                value="-1"
                checked={isAllChecked}
                onChange={handleCheckAll}
              />
            )}

            <Multiselect
              array={list}
              type="object"
              name="name"
              value="value"
              state={filterState}
              setState={setFilterState}
              valueType={valueType}
            />
          </div>

          <div className={styles.actions}>
            <Button
              color="light"
              classes={{ button: styles.button }}
              onClick={handleOrderClick}
              disabled={disabled}
            >
              {sortOrder === 'asc' ? 'A-Z' : 'Z-A'}
            </Button>

            <Button
              color="primary"
              classes={{ button: styles.button }}
              onClick={handleSubmit}
              disabled={disabled}
            >
              Filtruoti
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

SelectFilter.defaultProps = {
  position: 'left',
  disabled: false,
};

SelectFilter.propTypes = {
  array: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  valueType: PropTypes.string.isRequired,
  filterState: PropTypes.array.isRequired,
  setFilterState: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  sortOrder: PropTypes.oneOf(['asc', 'desc']).isRequired,
  setSortOrder: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

export default SelectFilter;
